const m = require('minthril');
const { component } = require('../../component');
const { Breadcrumbs } = require('../../components/breadcrumbs');
const { cancelBilling, loadBillingSummary } = require('../../controllers/billing');

function formatDate(value) {
  if (!value) return 'the end of your current billing period';
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeZone: 'UTC'
  }).format(new Date(value));
}

const BillingCancelPage = component((vnode, emit) => {
  let accountId = null;
  let summary = null;
  let error = null;
  let loading = false;
  let canceling = false;
  let canceled = false;

  async function load(user, loadKey) {
    accountId = loadKey;
    loading = true;
    error = null;
    emit('redraw');
    try {
      summary = await loadBillingSummary(user);
    } catch (reason) {
      error = reason.message;
    } finally {
      loading = false;
      emit('redraw');
    }
  }

  async function cancel(user) {
    canceling = true;
    error = null;
    emit('redraw');
    try {
      const result = await cancelBilling(user);
      canceled = true;
      summary = { ...summary, cancelAt: result.cancelAt };
    } catch (reason) {
      error = reason.message;
    } finally {
      canceling = false;
      emit('redraw');
    }
  }

  return {
    view: ({ attrs: { user, accountPath = '/account/billing' } }) => {
      if (accountId !== user.uid && !loading) load(user, user.uid);

      return m('section.panel.billing-cancel-page', [
        m(Breadcrumbs, { items: [{ label: 'Account', href: '/account' }, { label: 'Billing', href: accountPath }, { label: 'Cancel plan' }] }),
        m('h2', 'Cancel your Spache plan'),
        error && m('p.error', error),
        loading ? m('p.muted', 'Loading your plan…') : summary && !canceled && [
          m('p', 'Are you hella sure? Cancelling your plan will stop your connected domains from working when the current billing period ends.'),
          m('p', `You will keep access until ${formatDate(summary.nextPaymentAt)}.`),
          m('div.billing-cancel-page__actions', [
            m('a.button.button--quiet', { href: accountPath }, 'Keep my plan'),
            m('button.button.button--danger', {
              type: 'button',
              disabled: canceling,
              onclick: () => cancel(user)
            }, canceling ? 'Cancelling…' : 'Cancel plan')
          ])
        ],
        canceled && [
          m('p', `Your plan is cancelled and will remain active until ${formatDate(summary.cancelAt)}.`),
          m('a.button', { href: accountPath }, 'Back to billing')
        ]
      ]);
    }
  };
});

module.exports = { BillingCancelPage };
